import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'noCommaDecimal'
})

export class NoCommaDecimalPipe implements PipeTransform {

    transform(val) {
        if (val !== undefined && val !== null) {
            return parseFloat(val).toFixed(2);
        } else {
            return '';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/utilityServices/pipes/noComma.pipe.ts